/* 司馬懿傳・第 3 章：遼東・襄平（景初二年，238）
 * 史實：《晉書·宣帝紀》「文懿果遣步騎數萬，阻遼隧，堅壁而守，南北六七十里，以距帝。帝盛兵多張旗幟出其南，賊盡銳赴之。
 *       乃泛舟潛濟以出其北，與賊營相逼，沈舟焚梁，傍遼水作長圍，棄賊而向襄平。……賊見兵出其後，果邀之。
 *       帝謂諸將曰：『所以不攻其營，正欲致此，不可失也。』乃縱兵逆擊，大破之，三戰皆捷。賊保襄平，進軍圍之。」
 *       「會霖潦，大水平地數尺，三軍恐，欲移營。帝令軍中敢有言徙者斬。都督令史張靜犯令，斬之，軍中乃定。賊恃水，樵牧自若。
 *       諸將欲取之，皆不聽。」司馬陳珪問上庸之速、今日之緩，帝曰：「……自發京師，不憂賊攻，但恐賊走。今賊糧垂盡，而圍落未合，
 *       掠其牛馬，抄其樵采，此故驅之走也。」「既而雨止，遂合圍。起土山地道，楯櫓鉤橦，發矢石雨下，晝夜攻之。」
 *       「時有長星，色白，有芒鬣，自襄平城西南流于東北，墜於梁水，城中震慴。」王建、柳甫乞降，斬之；
 *       「軍事大要有五，能戰當戰，不能戰當守，不能守當走，餘二事惟有降與死耳。」「文懿攻南圍突出，帝縱兵擊敗之，斬于梁水之上星墜之所。」
 *       《三國志·公孫度傳》：卑衍、楊祚屯遼隧「圍塹二十餘里」；「會霖雨三十餘日，遼水暴長」；流星「從首山東北墜襄平城東南」。
 *       （《晉書》說長星自城西南流向東北，《公孫度傳》說自首山東北墜城東南，兩說方向不同；地圖照兩書都說的「梁水」放在城南。）
 * 流程（「等」與「快」都有）：在遼水南岸多張旗幟，把卑衍的兵引到南邊 → 北邊泛舟潛濟，沈舟焚梁 → 不攻遼隧，直趨襄平，
 *       回頭三戰皆捷 → 霖雨三十日：不准移營（斬張靜）、不搶樵牧，只等 → 雨止，快速堆起四座土山合圍 →
 *       長星墜於梁水，公孫淵從南門突圍，在星墜之所斬之。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout } from '../kit.ts';
import { MEN, TR, flag, mound, rain } from './simayi_kit.ts';
import { CITY, START, SUI, DOCK, LAND, CAMP, FLAGS, SGATE, WGATE, STAR, MOUNDS, GRAZE } from '../maps/simayi_liaodong.ts';

const LV = 15, RAIN_DAY = 1, RAIN_DAYS = 30, ESCAPE_X = 9650;
const LIAO = { spec: TR.liao, name: '遼東兵', hp: 640, maxHp: 640, atk: 30 };
const lowland = (x, y) => y > 2900 && SG.MAP.walkable(x, y, 0) && !SG.MAP.waterAt(x, y) && SG.gd(x, y, CAMP[0], CAMP[1]) > 600 && !(Math.abs(x - CITY.x) < CITY.hw + 60 && Math.abs(y - CITY.y) < CITY.hh + 60);

export default {
  id: 'simayi-3', map: 'simayi_liaodong', hero: 'simayi',
  title: '第 3 章　遼東・襄平', year: '景初二年（238）',
  brief: {
    quote: [{ text: '往百日，還百日，攻百日，以六十日為休息，一年足矣。', src: '《晉書·宣帝紀》' }, { text: '自發京師，不憂賊攻，但恐賊走。', src: '《晉書·宣帝紀》' }],
    text: '公孫淵據遼東自立為燕王。明帝問司馬懿公孫淵會用什麼計：「棄城預走，上計也；據遼水以距大軍，次計也；坐守襄平，此成擒耳。」司馬懿帶牛金、胡遵等步騎四萬出征，六月到遼水。公孫淵果然派卑衍、楊祚在遼隧築長圍阻擋。',
    goals: ['在遼水南岸多張旗幟，引開卑衍', '在北邊泛舟潛濟', '不攻遼隧，直趨襄平：賊兵追來就回頭打', '霖雨三十日：不移營、不搶樵牧', '雨止合圍：堆起四座土山', '斬公孫淵於梁水'],
  },
  words: { ally: '魏軍', foe: '遼東兵' },
  lowland: (m, x, y) => lowland(x, y),
  sail: (m, x, y) => x > 2050 && x < 2700 && y < 1500 && !SG.MAP.walkable(x, y, SG.MAP.BODY), // 渡船可以划進岸邊，靠岸
  stars: [
    { text: '霖雨中沒有去搶城外的樵牧', ok: (m) => !m.vars.raided },
    { text: '雨止後 60 秒內四座土山合圍', ok: (m) => m.vars.ringT != null && m.vars.ringT <= 60 },
    { text: '斬公孫淵於梁水之上星墜之所', ok: (m) => !!m.vars.atStar },
  ],
  steps: [
    { // 0. 盛兵多張旗幟出其南
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.niu = ally(w, MEN.niujin, me.x + 80, me.y - 90, LV - 1);
        V.hu = ally(w, MEN.huzun, me.x + 80, me.y + 90, LV - 1);
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x - 120 - (i % 4) * 50, me.y - 60 + Math.floor(i / 4) * 90, '魏兵'); u.spec = TR.wei; u.hp = u.maxHp = 760; u.atk = 30; m.join(u, me); return u; });
        V.sui = Array.from({ length: 12 }, (_, i) => { const a = (i / 12) * Math.PI * 2, u = m.foe('huangjin', SUI[0] + Math.cos(a) * 380, SUI[1] + Math.sin(a) * 260, LIAO); return u; });
        V.flags = FLAGS.map(() => false);
        FLAGS.forEach(([x, y], k) => m.mark('f' + k, x, y, '張旗', true));
        m.card('文懿果遣步騎數萬，阻遼隧，堅壁而守，南北六七十里，以距帝。', '《晉書·宣帝紀》');
        m.after(4, () => m.line('司馬懿', '賊堅營高壘，欲以老吾兵也。攻之，正入其計。先在南邊多張旗幟。'));
        m.after(8, () => m.line('提示', '在南岸三處「張旗」各站 1.2 秒插旗。旗多了，遼隧的兵就會以為魏軍要從南邊渡河。'));
        m.obj('flags', '在遼水南岸多張旗幟', 3);
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        FLAGS.forEach(([x, y], k) => { if (!V.flags[k]) m.chanAt(me, 'f' + k, x, y, 140, 1.2, '張旗', () => { V.flags[k] = true; m.unmark('f' + k); m.folk(x + 40, y - 20, { name: '旗', still: true, near: 1, draw: flag, text: '魏' }); }); });
        m.prog('flags', V.flags.filter(Boolean).length);
        return V.flags.every(Boolean);
      },
    },
    { // 1. 泛舟潛濟以出其北
      enter(m, w) {
        const V = m.vars;
        m.done('flags');
        m.card('帝盛兵多張旗幟出其南，賊盡銳赴之。', '《晉書·宣帝紀》');
        V.sui.forEach((u, i) => { u.home = [2850 + (i % 4) * 90, 3700 + Math.floor(i / 4) * 140]; }); // 遼隧的兵都往南岸去了
        m.mark('dock', DOCK[0], DOCK[1], '渡口');
        m.obj('cross', '到北邊的渡口，泛舟潛濟');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.boat && m.near(me, DOCK[0], DOCK[1], 220)) {
          m.unmark('dock');
          V.boat = m.boat(me, { x: 2200, y: DOCK[1], land: true, crew: [V.niu, V.hu].filter((u) => u.alive), onLand: () => { V.landed = true; } });
          m.mark('land', LAND[0], LAND[1], '對岸');
          m.line('司馬懿', '悄悄渡過去。');
        }
        return !!V.landed;
      },
    },
    { // 2. 沈舟焚梁，棄賊而向襄平：三戰皆捷
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('cross'); m.unmark('land');
        for (const u of m.alive(V.men)) { const p = SG.MAP.nearestFree(me.x + 60 + (SG.rand() - 0.5) * 120, me.y + (SG.rand() - 0.5) * 160); u.x = p[0]; u.y = p[1]; }
        m.card('乃泛舟潛濟以出其北，與賊營相逼，沈舟焚梁，傍遼水作長圍，棄賊而向襄平。', '《晉書·宣帝紀》');
        m.after(4, () => m.line('魏將', '不攻賊而作圍，非所以示眾也。'));
        m.after(8, () => m.line('司馬懿', '賊大眾在此，則巢窟虛矣。我直指襄平，則人懷內懼，懼而求戰，破之必矣。'));
        m.mark('go', CAMP[0], CAMP[1], '往襄平');
        m.obj('go', '不攻遼隧，直趨襄平');
        V.wave = 0;
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        // 走過首山以西：賊見兵出其後，果邀之
        if (!V.chased && me.x > 4300) {
          V.chased = true;
          m.big('賊兵追來了！');
          m.line('司馬懿', '所以不攻其營，正欲致此，不可失也！');
          rout(m, w, V.sui, [SUI[0], SUI[1] + 900]); // 南岸的兵太遠，追不上
          m.obj('fight', '縱兵逆擊：三戰皆捷', 3);
        }
        if (V.chased) {
          const cur = V.cur || [];
          if (!cur.some((u) => u.alive) && V.wave < 3) {
            V.wave++; m.prog('fight', V.wave - 1);
            const n = 5 + V.wave;
            V.cur = Array.from({ length: n }, (_, i) => { const u = m.foe('huangjin', me.x - 900 - (i % 3) * 70, me.y - 200 + Math.floor(i / 3) * 120, LIAO); u.home = [me.x, me.y]; return u; });
            if (V.wave === 3) { V.by = boss(w, MEN.beiyan, me.x - 1000, me.y, { name: '卑衍', hp: 5200, atk: 50, armor: 9, ms: 240 }); V.by.home = [me.x, me.y]; V.cur.push(V.by); m.mark('by', V.by.x, V.by.y, '卑衍', false, V.by); }
            m.line('遼東兵', ['追！別讓魏軍到襄平！', '殺回去！', '卑衍將軍親自來了！'][V.wave - 1]);
          }
          for (const u of m.alive(V.cur || [])) if (!(u.target && u.target.alive)) u.home = [me.x, me.y];
          if (V.wave === 3 && !V.cur.some((u) => u.alive)) { m.prog('fight', 3); return true; }
        }
        return false;
      },
    },
    { // 3. 霖雨：不移營、不搶樵牧
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('fight'); m.done('go'); m.unmark('by');
        m.card('乃縱兵逆擊，大破之，三戰皆捷。賊保襄平，進軍圍之。', '《晉書·宣帝紀》');
        m.mark('camp', CAMP[0], CAMP[1], '營');
        m.obj('camp', '回營，圍襄平');
        V.grazers = GRAZE.map(([x, y]) => [0, 1, 2].map((i) => { const u = m.foe('huangjin', x - 120 + i * 120, y + (i - 1) * 60, Object.assign({}, LIAO, { name: '樵牧', hp: 300, maxHp: 300, atk: 8 })); u.asleep = true; return u; })).flat();
        for (const [x, y] of GRAZE) for (let i = 0; i < 3; i++) m.folk(x - 160 + i * 150, y + 80, { name: '牛', still: true, near: 1, draw: ox });
        V.niu.hold = [CAMP[0] - 160, CAMP[1] + 120]; V.hu.hold = [CAMP[0] + 160, CAMP[1] + 120];
        for (const u of m.alive(V.men)) { u.owner = null; u.home = [CAMP[0] + (SG.rand() - 0.5) * 400, CAMP[1] + (SG.rand() - 0.5) * 200]; }
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (!V.rainT0) {
          if (!m.near(me, CAMP[0], CAMP[1], 400)) return false;
          V.rainT0 = w.t; V.rain = true; m.unmark('camp'); m.done('camp');
          m.big('霖雨');
          m.card('會霖潦，大水平地數尺，三軍恐，欲移營。', '《晉書·宣帝紀》');
          for (let i = 0; i < 6; i++) m.flood(5300 + i * 500, 3500);
          m.obj('rain', '');
          // 張靜犯令：帶著幾個兵往西北移營
          m.after(5, () => {
            V.zj = m.recruit(CAMP[0] - 420, CAMP[1] + 80, '都督令史張靜'); V.zj.spec = TR.wei; V.zj.home = [3800, 600]; V.zj.ms = 150; V.zj.noFight = true;
            V.zjMen = [0, 1, 2].map((i) => { const u = m.recruit(CAMP[0] - 440 - i * 40, CAMP[1] + 140, '魏兵'); u.spec = TR.wei; u.home = [3800, 660 + i * 50]; u.ms = 150; return u; });
            m.line('張靜', '水都淹到營裡了！移營！往高處移營！');
            m.line('司馬懿', '軍中敢有言徙者斬！');
            m.mark('zj', V.zj.x, V.zj.y, '張靜', false, V.zj);
            m.obj('zj', '張靜犯令：追上他，斬之');
          });
          m.after(14, () => m.line('牛金', '賊恃水，在城外樵牧自若。請派兵去取！'));
          m.after(20, () => { m.line('陳珪', '昔攻上庸，八部並進，晝夜不息，故能一旬之半，拔堅城，斬孟達。今者遠來而更安緩，愚竊惑焉。'); });
          m.after(25, () => m.line('司馬懿', '達眾少而食支一年，吾將士四倍于達而糧不淹月，以一月圖一年，安可不速？今賊眾我寡，賊飢我飽，水雨乃爾，雖當促之，亦何所為。'));
          m.after(30, () => m.line('司馬懿', '自發京師，不憂賊攻，但恐賊走。今賊糧垂盡，而圍落未合，掠其牛馬，抄其樵采，此故驅之走也。'));
          return false;
        }
        const d = (w.t - V.rainT0) / RAIN_DAY;
        m.get('rain').text = `霖雨（第 ${Math.min(RAIN_DAYS, Math.floor(d) + 1)}／${RAIN_DAYS} 日）・等雨停`;
        // 張靜：斬之，軍中乃定
        if (V.zj && V.zj.alive && !V.zjDone) {
          const caught = SG.gd(V.zj.x, V.zj.y, me.x, me.y) < 220; // 被司馬懿攔下就站住
          for (const u of [V.zj].concat(V.zjMen)) if (u.alive) u.home = caught ? [u.x, u.y] : [3800, 600];
          m.chanAt(me, 'zj', V.zj.x, V.zj.y, 200, 0.8, '斬', () => {
            V.zjDone = true; V.zj.alive = false; V.zj.counted = true; V.zj.deadT = w.t; m.unmark('zj'); m.done('zj');
            for (const u of V.zjMen) u.home = [CAMP[0] + (SG.rand() - 0.5) * 300, CAMP[1]];
            m.card('都督令史張靜犯令，斬之，軍中乃定。', '《晉書·宣帝紀》');
          }, { hurt: false });
          if (SG.gd(V.zj.x, V.zj.y, CAMP[0], CAMP[1]) > 1500) { m.lose('張靜帶頭移營，三軍跟著走，襄平的圍落大開'); return false; }
        }
        // 樵牧：殺了就是驅賊走
        if (!V.raided && V.grazers.some((u) => !u.alive || u.hp < u.maxHp)) { V.raided = true; m.line('司馬懿', '誰叫你們去搶的？賊糧垂盡，掠其牛馬，此故驅之走也！'); }
        for (const u of V.grazers) if (u.alive && u.hp < u.maxHp) u.asleep = false;
        return d >= RAIN_DAYS && (!V.zj || V.zjDone);
      },
    },
    { // 4. 雨止，合圍：起土山
      enter(m, w) {
        const V = m.vars;
        V.rain = false; m.drop('rain');
        for (const u of V.grazers) if (u.alive) { u.alive = false; u.counted = true; u.deadT = w.t; } // 樵牧退回城裡
        m.folks = m.folks.filter((f) => f.draw !== ox);
        m.card('既而雨止，遂合圍。起土山地道，楯櫓鉤橦，發矢石雨下，晝夜攻之。', '《晉書·宣帝紀》');
        V.ring0 = w.t; V.mounds = MOUNDS.map(() => null); V.sallyT = 6; V.arrowT = 2;
        V.pts = MOUNDS.map(([x, y]) => SG.MAP.nearestFree(x, y));
        V.pts.forEach(([x, y], k) => m.mark('m' + k, x, y, '土山', true));
        V.niu.hold = null; V.hu.hold = null;
        m.line('司馬懿', '雨停了——合圍！四面起土山，晝夜攻之！');
        m.after(3, () => m.line('提示', '在城的四角各站 2 秒，堆起土山。城裡會派兵出來搶，城上也會放箭。'));
        m.obj('ring', '四面起土山合圍', 4);
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.pts.forEach(([x, y], k) => {
          if (V.mounds[k]) return;
          m.chanAt(me, 'm' + k, x, y, 150, 2, '起土山', () => { m.unmark('m' + k); V.mounds[k] = m.folk(x, y - 30, { name: '土山', still: true, near: 1, draw: mound }); });
        });
        const n = V.mounds.filter(Boolean).length;
        m.prog('ring', n);
        if ((V.sallyT -= dt) <= 0) { V.sallyT = 9; const g = SG.rand() < 0.5 ? WGATE : SGATE; for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', g[0] + (g === WGATE ? -120 : 0), g[1] + (g === SGATE ? 120 : 0) + (i - 1.5) * 60, LIAO); u.home = [me.x, me.y]; } }
        if (Math.abs(me.x - CITY.x) < CITY.hw + 450 && Math.abs(me.y - CITY.y) < CITY.hh + 400 && (V.arrowT -= dt) <= 0) { V.arrowT = 3; m.strike(me.x, me.y, 90, 1, 55, 0); }
        if (n < 4) return false;
        V.ringT = w.t - V.ring0;
        return true;
      },
    },
    { // 5. 長星墜於梁水：斬公孫淵
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('ring');
        m.card('時有長星，色白，有芒鬣，自襄平城西南流于東北，墜於梁水，城中震慴。', '《晉書·宣帝紀》');
        V.star = w.t;
        V.niu.hold = [STAR[0] + 500, STAR[1] - 250]; V.hu.hold = [STAR[0] + 650, STAR[1] - 120]; // 南圍：牛金、胡遵守在梁水邊
        m.mark('star', STAR[0], STAR[1], '星墜之所');
        m.after(5, () => {
          m.folk(WGATE[0] - 140, WGATE[1], { name: '王建', still: true, near: 1 });
          m.line('王建', '燕王願解圍面縛……請大軍退舍。');
          m.after(3, () => m.line('司馬懿', '昔楚鄭列國，而鄭伯猶肉袒牽羊而迎之。孤為王人，位則上公——斬！'));
          m.after(7, () => m.card('軍事大要有五，能戰當戰，不能戰當守，不能守當走，餘二事惟有降與死耳。汝不肯面縛，此為決就死也。', '司馬懿謂衞演，《晉書·宣帝紀》'));
        });
        m.after(14, () => {
          m.big('公孫淵從南門突圍！');
          m.card('文懿攻南圍突出，帝縱兵擊敗之。', '《晉書·宣帝紀》');
          V.yuan = boss(w, MEN.gongsunyuan, SGATE[0], SGATE[1] + 80, { name: '公孫淵', hp: 3400, atk: 46, armor: 8, ms: 205 });
          V.yuan.home = [STAR[0], STAR[1] - 120]; V.yuan.run = 0;
          V.guard = Array.from({ length: 6 }, (_, i) => { const u = m.foe('huangjin', SGATE[0] - 100 + (i % 3) * 80, SGATE[1] + 160 + Math.floor(i / 3) * 80, Object.assign({}, LIAO, { name: '燕騎', ms: 240 })); u.home = [STAR[0] - 100 + (i % 3) * 80, STAR[1] - 200]; return u; });
          m.mark('yuan', V.yuan.x, V.yuan.y, '公孫淵', false, V.yuan);
          m.obj('yuan', '斬公孫淵');
        });
        m.obj('wait', '城中震慴……守住南圍');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, y = V.yuan;
        if (!y) return false;
        // 公孫淵：往梁水邊跑，再沿河往東逃；被纏住了才回手
        if (y.alive) {
          if (!(y.target && y.target.alive && SG.gd(y.target.x, y.target.y, y.x, y.y) < 200)) { y.target = null; y.think = 0.4; }
          if (SG.gd(y.x, y.y, y.home[0], y.home[1]) < 80) y.home = [ESCAPE_X + 200, STAR[1] - 220];
          if (y.x > ESCAPE_X) { m.lose('公孫淵突圍逃走了'); return false; }
          return false;
        }
        m.done('yuan'); m.done('wait'); m.unmark('yuan'); m.unmark('star');
        V.atStar = SG.gd(y.x, y.y, STAR[0], STAR[1]) < 700;
        m.card(V.atStar ? '斬于梁水之上星墜之所。' : '斬文懿父子。', '《晉書·宣帝紀》');
        rout(m, w, w.units.filter((u) => u.team === 1 && u.alive), [CITY.x, CITY.y]);
        m.after(5, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('司馬懿陣亡'); return; }
    for (const u of [V.niu, V.hu]) if (u) { allyTick(w, u, w.player, 480); if (u.hp < u.maxHp * 0.3) u.hp = u.maxHp * 0.3; }
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.rain) rain(ctx, x0, y0, vw, vh, view.WS.time); },
};

// 牛（樵牧的牛馬）
function ox(ctx, f, T) {
  const { poly } = SG.draw;
  ctx.save(); ctx.translate(f.x, f.y); ctx.scale(f.f || 1, 1);
  SG.draw.castShadow(ctx, 0, 2, 34, 9, 60, 0.3);
  poly(ctx, [[-30, -14], [24, -14], [26, -40], [-28, -40]], '#6a5040', 2);
  poly(ctx, [[24, -40], [42, -36], [42, -24], [26, -22]], '#5a4032', 1.6);
  for (const x of [-22, -8, 10, 20]) poly(ctx, [[x, -14], [x + 5, -14], [x + 5, 0], [x, 0]], '#4a3428', 1);
  ctx.restore();
}
